import React, {useEffect, Fragment} from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import determineIfMobile from '@homeaway/react-determine-if-mobile';

import {TABLET_BREAKPOINT} from '../utils/constants';
import {TESTS} from '../utils/abacus';

import AboveFold from '../components/common/above-fold/AboveFold';
import MvtTest from '../components/common/mvt/MvtTest/MvtTest';
import LinkPilesModule from '../modules/LinkPiles/LinkPilesModule';
import SEOTextModule from '../modules/seo-text/SEOTextModule';
import PopularDestinationsModule from '../modules/PopularDestinations/PopularDestinationsModule';
import PropertyTypesModule from '../modules/PropertyTypes/PropertyTypesModule';
import {AsyncNeighborhoods} from '../modules/Neighborhoods/AsyncNeighborhoods';
import GreatPlacesToStayModule from '../modules/GreatPlacesToStay/GreatPlacesToStayModule';
import {DateModal} from '../components/common/date-modal/DateModal';
import {AsyncDestinationUrgency} from '../modules/UrgencyMessage/AsyncDestinationUrgency';
import ReviewsModule from '../modules/Review/ReviewsModule';
import DynamicSeoLinkpile from '../components/common/seo-linkpile/DynamicSeoLinkpile';
import ScrollToTopModule from '../modules/ScrollToTop/ScrollToTopModule';
import {AsyncRecentTravelerActivity} from '../modules/RecentTravelerActivity/AsyncRecentTravelerActivity';
import DynamicQuestionsModule from '../modules/DynamicQuestions/DynamicQuestionsModule';
import ValuePropsModule from '../modules/ValueProps/ValuePropsModule';
import {AsyncToaster} from '../components/common/toaster/AsyncToaster';
import {AsyncTripBoardModal} from '../components/common/tripboard/AsyncTripBoardModal';
import {AsyncRecommendedProperties} from '../modules/RecommendedProperties/AsyncRecommendedProperties';
import {AsyncMapProperties} from '../components/destination/map-properties/AsyncMapProperties';
import DynamicDestinationRefinements from '../modules/DynamicDestinationRefinements';
import {PointsOfInterestModule} from '../modules/PointsOfInterest/PointsOfInterestModule';
import {AsyncTrustpilot} from '../modules/Trustpilot/AsyncTrustpilot';

import {
    fullExposures,
    lazy,
    withErrorBoundary,
    withTripboardsLazy,
    withTripboards,
} from './helpers';

export const fullExposureTests = [
    TESTS.BREADCRUMB_IN_HEADER,
    TESTS.DYNAMIC_RENDERING_2,
    TESTS.SLP_TRAFFIC_TEST_AA,
    TESTS.TRIPBOARDS_SAVE_LABEL,
    TESTS.SLP_TOP_X_BEST_META_TITLE_TRAFFIC_TEST,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_BANNER,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_ALERT,
    TESTS.DISCOVERY_SITE_NAVIGATION,
    TESTS.DISCOVERY_SITE_NAVIGATION_NEW_LABEL,
    TESTS.VRBO_LANDING_SLP_BRANDED_HEADINGS,
    TESTS.VRBO_LANDING_UPDATED_BREADCRUMB,
    TESTS.VRBO_LANDING_UPDATED_BREADCRUMB_SEO,
];

function TemplateComponent(props) {
    const {
        isMobile,
        hasTouch,
        dispatch,
        allowPlaceholders,
        mabComponents,
        showPoiMap,
    } = props;

    useEffect(() => {
        dispatch({
            type: 'SET_VIEWPORT',
            payload: {isMobile, hasTouch},
        });
    }, [dispatch, isMobile, hasTouch]);

    const mainCSSClass = classNames('app-main', {
        'container--loading__visible': allowPlaceholders,
    });

    // Note : neighborhoods is fallback of popularDestination
    // It is not a requirment so leave it as it is.
    const COMPONENTS = {
        'dynamic-refinements': lazy(<DynamicDestinationRefinements />),
        'urgency-banner': lazy(<AsyncDestinationUrgency />),
        'property-types': lazy(<PropertyTypesModule />),
        'popular-destination': lazy(<PopularDestinationsModule />),
        map: showPoiMap
            ? lazy(<PointsOfInterestModule />)
            : lazy(<AsyncMapProperties />),
        reviews: withTripboards(<ReviewsModule />),
        'property-listing': withTripboards(<GreatPlacesToStayModule />),
        'value-props': lazy(<ValuePropsModule />),
        neighborhoods: lazy(<AsyncNeighborhoods />),
        'seo-accordion': lazy(<SEOTextModule />),
        trustpilot: lazy(<AsyncTrustpilot />),
    };

    return (
        <>
            <main className={mainCSSClass}>
                {/* STATIC */}
                {fullExposures([...fullExposureTests])}
                <AboveFold />
                <MvtTest test={TESTS.SLP_ADAPTIVE_LAYOUT_MAB} />
                {lazy(<ScrollToTopModule />)}
                {withTripboardsLazy(<AsyncRecentTravelerActivity />)}
                {withTripboardsLazy(<AsyncRecommendedProperties />)}
                {/* DYNAMIC */}
                {mabComponents?.map((e, i) => (
                    <Fragment key={i}>{withTripboards(COMPONENTS[e])}</Fragment>
                ))}
                {/* STATIC */}
                {withErrorBoundary(<DynamicQuestionsModule />)}
                {withErrorBoundary(<LinkPilesModule />)}
                {withErrorBoundary(<DateModal />)}
            </main>
            {withErrorBoundary(<DynamicSeoLinkpile />)}
            {withErrorBoundary(<AsyncToaster />)}
            {withErrorBoundary(<AsyncTripBoardModal />)}
        </>
    );
}

export function mapStateToProps({options, mab, pointsOfInterest}) {
    return {
        allowPlaceholders: options.allowPlaceholders,
        mabComponents: mab?.arm,
        showPoiMap: pointsOfInterest.hasData,
    };
}

export const Template = connect(mapStateToProps)(
    determineIfMobile(TemplateComponent, TABLET_BREAKPOINT)
);

Template.displayName = 'Template';

export default Template;
